var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default card-view"},[_c('div',{staticClass:"panel-wrapper collapse in"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('p',[_vm._v("Remarks")]),_c('div',{staticClass:"col-md-6"}),_c('div',{staticClass:"col-md-6"})])])])])])
}]

export { render, staticRenderFns }